/**
 * Created by fgourlot on 05/10/17.
 */
export class Transaction {
    private _id: string;
    private _startDate: string;
    private _endDate: string;
    private _feature: string;
    private _functionality: string;
    private _pageId: string;
    private _partner: string;
    private _service: string;
    private _httpMethod: string;
    private _status: string;
    private _code: string;
    private _errorMessage: string;
    private _commentary: string;
    private _originId: string;
    private _consumerId: string;
    private _sessionId: string;

    public get id(): string {
        return this._id;
    }

    public set id(value: string) {
        this._id = value;
    }

    public get startDate(): string {
        return this._startDate;
    }

    public set startDate(value: string) {
        this._startDate = value;
    }

    public get endDate(): string {
        return this._endDate;
    }

    public set endDate(value: string) {
        this._endDate = value;
    }

    public get feature(): string {
        return this._feature;
    }

    public set feature(value: string) {
        this._feature = value;
    }

    public get functionality(): string {
        return this._functionality;
    }

    public set functionality(value: string) {
        this._functionality = value;
    }

    public get pageId(): string {
        return this._pageId;
    }

    public set pageId(value: string) {
        this._pageId = value;
    }

    public get service(): string {
        return this._service;
    }

    public set service(value: string) {
        this._service = value;
    }

    public get partner(): string {
        return this._partner;
    }

    public set partner(value: string) {
        this._partner = value;
    }

    public get httpMethod(): string {
        return this._httpMethod;
    }

    public set httpMethod(value: string) {
        this._httpMethod = value;
    }

    public get status(): string {
        return this._status;
    }

    public set status(value: string) {
        this._status = value;
    }

    public get code(): string {
        return this._code;
    }

    public set code(value: string) {
        this._code = value;
    }

    public get errorMessage(): string {
        return this._errorMessage;
    }

    public set errorMessage(value: string) {
        this._errorMessage = value;
    }

    public get commentary(): string {
        return this._commentary;
    }

    public set commentary(value: string) {
        this._commentary = value;
    }

    public get originId(): string {
        return this._originId;
    }

    public set originId(value: string) {
        this._originId = value;
    }

    public get consumerId(): string {
        return this._consumerId;
    }

    public set consumerId(value: string) {
        this._consumerId = value;
    }

    public get sessionId(): string {
        return this._sessionId;
    }

    public set sessionId(value: string) {
        this._sessionId = value;
    }
}
